function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useState } from 'react';
var a11yRegionId = 'a11y-region';
var defaultText = '';
var defaultTone = 'polite';
var defaultRole = 'status';

function getA11yRegion() {
  /* istanbul ignore next */
  if (typeof document === 'undefined') {
    return null;
  }

  var a11yRegion = document.getElementById(a11yRegionId);

  if (a11yRegion) {
    return a11yRegion;
  }

  a11yRegion = document.createElement('div');
  a11yRegion.setAttribute('id', a11yRegionId);
  a11yRegion.setAttribute('role', defaultRole);
  a11yRegion.setAttribute('aria-live', defaultTone);
  a11yRegion.setAttribute('aria-atomic', 'true');
  Object.assign(a11yRegion.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  document.body.appendChild(a11yRegion);
  return a11yRegion;
}

export function useA11yAnnounce() {
  var _useState = useState(defaultText),
      _useState2 = _slicedToArray(_useState, 2),
      message = _useState2[0],
      setMessage = _useState2[1];

  var _useState3 = useState(defaultTone),
      _useState4 = _slicedToArray(_useState3, 2),
      tone = _useState4[0],
      setTone = _useState4[1];

  var _useState5 = useState(defaultRole),
      _useState6 = _slicedToArray(_useState5, 2),
      role = _useState6[0],
      setRole = _useState6[1];

  function setA11yMessage(messageText, messageTone, messageRole) {
    setMessage(messageText || defaultText);
    setTone(messageTone || defaultTone);
    setRole(messageRole || defaultRole);
  }

  function resetA11yMessage() {
    var a11yRegion = document.getElementById(a11yRegionId);

    if (a11yRegion) {
      setMessage(defaultText);
      setTone(defaultTone);
      setRole(defaultRole);
      a11yRegion.parentNode.removeChild(a11yRegion);
      getA11yRegion(); // force recreating aria live region in case message/tone/role is already default value
    }
  }

  useEffect(function () {
    var region = getA11yRegion();
    region.setAttribute('aria-live', tone);
    region.setAttribute('role', role);
    region.textContent = message;
  }, [message, tone, role]);
  return {
    setA11yMessage: setA11yMessage,
    resetA11yMessage: resetA11yMessage,
    message: message,
    tone: tone
  };
}